import {Course, Lesson, TEST_STATE, Task, TestResult} from "../common/course";
import CoursesRepository, {ICoursesrepository} from "../repositories/courses";

export class CoursesService {
    private repository: ICoursesrepository;
    constructor(repositoriInstance: ICoursesrepository) {
        this.repository = repositoriInstance;
    }
    getCourses(): Course[] {
        return this.repository.getCourses();
    }

    getCourseLessons(courseId: Course['id']) {
        return this.repository.getCourseLessons(courseId);
    }
    getLesson(lessonId: Lesson['id']) {
        return this.repository.getLesson(lessonId);
    }
    markTaskAsVisited({lessonId, taskId}: {lessonId: Lesson['id'], taskId: Task['id']}) {
        return this.repository.markTaskAsVisited({lessonId, taskId});
    }
    getTasksByCourseId(courseId: Course['id']) {
        return this.repository.getTasksByCourseId(courseId);
    }
    getTestById(testId: string) {
        return this.repository.getTestById(testId);
    }
    sendTestResults(params: TestResult) {
        return this.repository.sendTestResults(params);
    }
    getTestLastSubmition(testId: string) {
        //@ts-expect-error
        return this.repository.getTestLastSubmition(testId).catch(err => {
            if (err.response.status !== 404) {
                throw err;
            }
            return {
                state: TEST_STATE.NOT_STARTED,
            }
        });
    }
}

const coursesService = new CoursesService(new CoursesRepository);

export default coursesService;